<template>
  <card-component title="Binomios" :subtitle="subtitle" class="has-table has-mobile-sort-spaced" :header-search-input="false">
    <div slot="headerRight" class="card-header-icon">
      <b-button type="is-link" class="is-pulled-right" @click="downloadAssignments" :loading="isDownloading">
        <b-icon
            icon="file-download"></b-icon>
      </b-button>
    </div>
    <b-table
      :loading="isLoading"
      :paginated="paginated"
      :per-page="perPage"
      :striped="isStriped"
      :hoverable="hoverable"
      default-sort="rider"
      default-sort-direction="asc"
      :data="filterResultsByRiders"
      slot="content"
    >
      <template slot-scope="props">
        <b-table-column label="Jinete" field="rider.lastname">
          <link-to-detail type="rider" :resource-id="props.row.rider.id"> {{`${props.row.rider.lastname} ${props.row.rider.name}`}} </link-to-detail>
        </b-table-column>
        <b-table-column label="Caballo" field="horse.name">
          <link-to-detail type="horse" :resource-id="props.row.horse.id">
          <horse-gender :gender-code="'f'" v-if="props.row.horse.gender  == 'F'" />
          <horse-gender :gender-code="'m'" v-else-if="props.row.horse.gender  == 'M'" />
          {{`${props.row.horse.name}`}} </link-to-detail>
        </b-table-column>
        <b-table-column label="Nivel Actual" field="start_at" centered >
          <lesson-pdf-button :type="props.row.horse.status" v-if="props.row.horse.status && props.row.horse.lesson" :lesson-id="props.row.horse.lesson.id" :text="props.row.horse.lesson.name"/>
          <lesson-pdf-button v-else-if="props.row.horse.lesson" :lesson-id="props.row.horse.lesson.id" :text="props.row.horse.lesson.name"/>
          <b-tag type="is-light" v-else>S/I</b-tag>
        </b-table-column>
        <b-table-column label="Edad" field="birth_date" centered >
          <horse-age v-if="props.row.horse.birth_date" :brithday="props.row.horse.birth_date"/>
        </b-table-column>
        <b-table-column label="Asignado" field="startDate"><a style="cursor: pointer;" @click="$emit('edit', props.row)">{{ moment(props.row.start_date, 'YYYY-MM-DD') | moment('L')}}</a></b-table-column>
        <b-table-column label="Transcurrido" field="startDate">{{ moment(props.row.start_date, 'YYYY-MM-DD hh:mm:ss').fromNow()}}</b-table-column>
        <b-table-column label="Acciones">
          <div class="buttons is-right">
<!--            <b-button type="is-primary" size="is-small" @click="$emit('edit', props.row)">Modificar</b-button>-->
            <b-button type="is-danger" size="is-small" icon-left="close" @click="confirmCustomDelete(props.row.horse.id, props.row.id)" :loading="props.row.id == rowUnassign && isLoadingUnassign">Quitar</b-button>
          </div>
        </b-table-column>
      </template>

      <section class="section" slot="empty">
        <div class="content has-text-grey has-text-centered">
          <template v-if="isLoading">
            <p>
              <b-icon icon="dots-horizontal" size="is-large" />
            </p>
            <p>Cargando Resultados...</p>
          </template>
          <template v-else>
            <p>
              <b-icon icon="horseshoe" size="is-large" />
            </p>
            <p>No hay Resultados&hellip;</p>
          </template>
        </div>
      </section>
    </b-table>
  </card-component>
</template>

<script>
import TenantService from '@/services/TenantService'
import HorseService from '@/services/HorseService'
import HorseAge from '@/components/HorseAge'
import HorseGender from '@/components/HorseGender'
import LinkToDetail from '@/components/LinkToDetail'
import LessonPdfButton from '@/components/LessonPDFButton'
import CardComponent from '@/components/CardComponent'

export default {
  props: {
    reload: {
      type: Boolean,
      required: true
    },
    riderId: {
      type: Number,
      required: false,
      default: null
    }
  },
  components: {
    HorseAge,
    HorseGender,
    LinkToDetail,
    LessonPdfButton,
    CardComponent
  },
  created () {
    this.getHistory()
  },
  data () {
    return {
      results: [],
      paginated: true,
      perPage: 10,
      isStriped: true,
      hoverable: true,
      isLoading: false,
      isLoadingUnassign: false,
      rowUnassign: null,
      reloadTable: false,
      isDownloading: false
    }
  },
  methods: {
    async getHistory () {
      this.isLoading = true
      let params = {
        'active': true,
        'include[0]': 'rider',
        'include[1]': 'horse.lesson',
        'order': 'rider_name'
      }
      let response = await TenantService.getHistoryAssignments(params)
      this.results = response.data.data
      this.extractTopRanking()
    },
    extractTopRanking () {
      this.results.forEach(item => {
        if (item.lesson_status) {
          if (item.lesson_status === 'medium') {
            item.horse['status'] = 'is-warning'
          } else if (item.lesson_status === 'high') {
            item.horse['status'] = 'is-success'
          } else if (item.lesson_status === 'low') {
            item.horse['status'] = 'is-danger'
          }
        }
      })
      this.isLoading = false
    },
    confirmCustomDelete (horseId, rowId) {
      this.$buefy.dialog.confirm({
        title: 'Quitar Asignación',
        message: '¿Seguro que desea <b>quitar</b> la asignación? Esta acción no se puede deshacer.',
        confirmText: 'Quitar',
        cancelText: 'Cancelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.unassign(horseId, rowId)
      })
    },
    async unassign (horseId, rowId) {
      this.rowUnassign = rowId
      this.isLoadingUnassign = true
      let data = {
        'rider_id': null
      }
      try {
        let response = await HorseService.updateHorse(horseId, data)
        this.isLoadingUnassign = false
        if (response && response.status === 200) {
          this.success()
          this.getHistory()
        } else {
          this.error()
        }
      } catch (error) {
        console.log(error)
        this.isLoadingUnassign = false
        this.error()
      }
    },
    success () {
      this.$buefy.toast.open({
        message: 'Se ha desvinculado caballo correctamente',
        type: 'is-success'
      })
    },
    error () {
      this.$buefy.toast.open({
        message: 'No se pudo desvincular el caballo',
        type: 'is-danger'
      })
    },
    downloadAssignments () {
      this.isDownloading = true
      this.openAlert()
      let params = {
        'active': true
      }
      TenantService.downloadHistoryAssigments(params).then(
        (resp) => {
          let blob = new Blob([resp.data], { type: 'application/pdf' })

          var fileURL = window.URL.createObjectURL(blob)
          var fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', `Asignación Caballos ${this.$moment().format('LL')}.pdf`)
          document.body.appendChild(fileLink)
          fileLink.click()
          this.isDownloading = false
        },
        (err) => {
          console.log(err)
          this.isDownloading = false
        }
      )
    },
    openAlert () {
      this.$buefy.notification.open({
        duration: 4000,
        icon: 'account',
        message: `<icon class="mdi mdi-24px mdi-download"></icon> La descarga comenzará dentro de poco`,
        position: 'is-bottom-left',
        type: 'is-info',
        hasIcon: false
      })
    }
  },
  watch: {
    riderId (value) {
      this.getHistory()
    },
    reload (value) {
      if (value) {
        this.getHistory()
        this.$emit('update:reload', false)
      }
    }
  },
  computed: {
    filterResultsByRiders () {
      return this.results
        .filter((result) => {
          if (!result.horse || !result.rider) {
            console.warn('Asignación con caballo o jinete eliminado, se omite de la tabla:', result)
            return false
          }
          return true
        })
        .filter((result) => {
          if (this.riderId) {
            return result.rider_id === this.riderId
          } else {
            return true
          }
        })
    },
    subtitle () {
      let dataLenght = this.filterResultsByRiders.length
      let plural = dataLenght === 1 ? '' : 's'
      return `${dataLenght} binomio${plural} registrado${plural}`
    }
  }
}
</script>
